import $ from 'jquery'
import 'slick-carousel'

import BreakpointSubjectFactory from '../common-util/responsive/breakpoint-subject-factory'

export default class PhotoGalleryController {
  constructor (element, breakpoints) {
    this._breakpointSubjectFactory = new BreakpointSubjectFactory(breakpoints)
    this._element = element
    this._initSlider()
  }

  _initSlider () {
    const breakpointDownSm$ = this._breakpointSubjectFactory.getBreakpointUpSubject(
      'lg'
    )

    const sliderElement = this._element.querySelector('.photo-gallery__items')
    if (sliderElement) {
      const $slickElement = $(sliderElement)
      let slickActive = false
      breakpointDownSm$.subscribe(isActive => {
        if (isActive) {
          if (!slickActive) {
            slickActive = true
            $slickElement.slick({
              slidesToShow: 1,
              infinite: true,
              autoplay: true,
              autoplaySpeed: 4000,
              speed: 500,
              mobileFirst: true,
              prevArrow: '.photo-gallery__nav-button--previous',
              nextArrow: '.photo-gallery__nav-button--next',
              pauseOnHover: false,
              swipeToSlide: false,
              draggable: false,
              waitForAnimate: false,
              fade: true
            })
          }
        } else {
          if (slickActive) {
            slickActive = false
            $slickElement.slick('unslick')
          }
        }
      })
    }
  }
}
